import React from 'react';
import { url } from '../../Config/config';
import { Grid, Box } from '@material-ui/core';
import AudioPlayerAdmin from '../../../../components/AudioPlayerAdmin';

const condition = ['png', 'jpg', 'jpeg'];
const EditHintDisplay = ({ displayHints }) => {
  return (
    <>
      {displayHints &&
        <Grid container spacing={1}>
          {displayHints.map((data, idx) => (
            (data.mediaType).split("/")[0] === "video" ?
              <Grid key={idx} item lg={4} md={6} xs={12}>
                <video
                  preload="auto"
                  controls
                  controlsList="nodownload"
                  style={{
                    top: 8,
                    borderRadius: 1,
                    border: "2px solid #000",
                    objectFit: 'fit',
                    padding: '5px',
                    width: 'calc(100% - 16px)',
                    height: 'calc(100% - 16px)'
                  }}
                >
                  <source src={`${url}${data.url}`}></source>
                </video>
              </Grid>
              : (data.mediaType).split("/")[0] === "image" ?
                <Grid key={idx} item lg={4} md={6} xs={12}>
                  <Box
                    component="img"
                    alt="file preview"
                    src={`${url}${data.url}`}
                    sx={{
                      top: 8,
                      borderRadius: 1,
                      border: "2px solid #000",
                      objectFit: 'fit',
                      padding: '5px',
                      width: 'calc(100% - 16px)',
                      height: 'calc(100% - 16px)'
                    }}
                  />
                </Grid>
                : (data.mediaType).split("/")[0] === "audio" ?
                  <Grid key={idx} item lg={12} md={12} xs={12}>
                    <div id="hint-need-audio">
                      <AudioPlayerAdmin src={`${url}${data.url}`} />
                    </div>
                  </Grid>
                  : <></>
          ))}

        </Grid>
      }
    </>
  );
};

export default EditHintDisplay;
